import React from 'react';
import ChatSidebar from './ChatSidebar';
import './ChatSidebarWrapper.css';

interface ChatSidebarWrapperProps {
  currentSessionId: string;
  onSessionSelect: (sessionId: string) => void;
  onNewChat: () => void;
}

const ChatSidebarWrapper: React.FC<ChatSidebarWrapperProps> = (props) => {
  return (
    <div className="chat-sidebar-wrapper">
      <ChatSidebar {...props} />
    </div>
  );
};

export default ChatSidebarWrapper;